import { useCallback, useEffect, useState } from "react";
import {
  createRecruiterJob,
  listRecruiterJobs,
  updateRecruiterJobStatus
} from "../services/jobService";

export default function useRecruiterJobs(user) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const loadJobs = useCallback(async (silent = false) => {
    try {
      if (!silent) setLoading(true);
      setError("");
      const result = await listRecruiterJobs(user);
      setJobs(result);
    } catch (err) {
      console.error("Failed to load recruiter jobs:", err);
      if (!silent) setError(err.message || "Unable to load jobs");
    } finally {
      if (!silent) setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    loadJobs();
  }, [loadJobs]);

  const createJob = useCallback(async (values) => {
    try {
      setSaving(true);
      setError("");
      const jobId = await createRecruiterJob(values, user);
      await loadJobs();
      return jobId;
    } catch (err) {
      console.error("Failed to create recruiter job:", err);
      setError(err.message || "Unable to create job");
      throw err;
    } finally {
      setSaving(false);
    }
  }, [loadJobs, user]);

  const toggleJobStatus = useCallback(async (job) => {
    const nextStatus = job.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    try {
      setError("");
      setJobs((currentJobs) =>
        currentJobs.map((item) =>
          item.jobId === job.jobId ? { ...item, status: nextStatus } : item
        )
      );
      await updateRecruiterJobStatus(job.jobId, nextStatus);
    } catch (err) {
      console.error("Failed to update job status:", err);
      setError(err.message || "Unable to update job status");
      await loadJobs();
    }
  }, [loadJobs]);

  return {
    jobs,
    loading,
    saving,
    error,
    reload: loadJobs,
    createJob,
    toggleJobStatus
  };
}
